export const PROVIDERS = {
  DEVICES: 'devices',
  CCD: 'ccd',
  ALL_SOURCES: 'all_sources',
  LOCAL: 'local',
  APPLE: 'apple',
  FITBIT: 'fitbit',
  WITHINGS: 'withings',
  GOOGLE_FIT: 'google_fit',
  TENOVI: 'tenovi',
  I_HEALTH: 'ihealth',
};

export const PROVIDER_ALL = 'all';

export const PROVIDER_OPTION = {
  ICON: 'icon',
  NAME: 'name',
  NAME_ID: 'name_id',
  OPTIONS: 'options',
  RESOURCES: 'resources',
  ACTIVE_ICON: 'active_icon',
  DISABLED_ICON: 'disabled_icon',
  SINGLE_VALUE_ICON: 'single_value_icon',
  ACTIVE_SINGLE_VALUE_ICON: 'active_single_value_icon',
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/constants/PROVIDERS.js